import { getKeycloakAccessToken } from '@src/utils/auth'
import { useToastStore } from '@src/utils/stores/toast'
import axios, { AxiosError } from 'axios'
import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

const api = axios.create({
    baseURL: import.meta.env.VITE_API_ENDPOINT,
    timeout: 100000,
})

api.interceptors.request.use(
    async (config) => {
        if (config.headers) {
            config.headers.Authorization = `Bearer ${await getKeycloakAccessToken()}`
        } else {
            config.headers = {
                Authorization: `Bearer ${await getKeycloakAccessToken()}`,
            } as never
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

const useEditLock = (entityType: string, entityId: string) => {
    const router = useRouter()
    const toast = useToastStore()

    const LOCK_INTERVAL =
        import.meta.env.VITE_EDIT_LOCK_HEARTBEAT_INTERVAL_SECONDS || 15

    let intervalId: ReturnType<typeof setInterval> | null = null

    onMounted(async () => {
        try {
            const lockResponse = await api.post('manage/edit-locks', {
                editable_id: entityId,
                editable_type: entityType,
            })

            if (lockResponse.status === 200) {
                intervalId = setInterval(() => {
                    api.post('manage/edit-locks/heartbeat', {
                        editable_id: entityId,
                        editable_type: entityType,
                    })
                }, LOCK_INTERVAL * 1000)
            }
        } catch (error) {
            if (error instanceof AxiosError && error.response?.status === 403) {
                toast.error(error.response.data.message)
                router.back()
            }
        }
    })

    onUnmounted(() => {
        if (intervalId) {
            clearInterval(intervalId)
        }
    })
}

export default useEditLock
